import React from "react";
import { Tooltip } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  arrow: {
    color: theme.palette.common.white
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: "1em",
    minWidth: "100%",
    maxWidth: "none",
    padding: theme.spacing(2),
    display: "block"
  },
  tooltipNarrow: {
    padding: theme.spacing(1)
  }
}));
const StyledTooltip = ({ element, title, hideTooltip, narrow, ...otherProps }) => {
  const { classes, cx } = useClasses();
  return !hideTooltip ? /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      arrow: true,
      title,
      classes: { ...classes, tooltip: cx(classes.tooltip, { [classes.tooltipNarrow]: narrow }) },
      ...otherProps
    },
    element
  ) : element;
};
export {
  StyledTooltip,
  StyledTooltip as default,
  useClasses
};
//# sourceMappingURL=Tooltip.js.map
